// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AdminRegion } from './AdminRegion';
import {
  AdminRegionFromJSON,
  AdminRegionFromJSONTyped,
  AdminRegionToJSON,
  AdminRegionToJSONTyped,
} from './AdminRegion';

/**
 *
 * @export
 * @interface ListAdminRegions200Response
 */
export interface ListAdminRegions200Response {
  /**
   *
   * @type {Array<AdminRegion>}
   * @memberof ListAdminRegions200Response
   */
  data: Array<AdminRegion>;
}

/**
 * Check if a given object implements the ListAdminRegions200Response interface.
 */
export function instanceOfListAdminRegions200Response(
  value: object,
): value is ListAdminRegions200Response {
  if (!('data' in value) || value['data'] === undefined) return false;
  return true;
}

export function ListAdminRegions200ResponseFromJSON(
  json: any,
): ListAdminRegions200Response {
  return ListAdminRegions200ResponseFromJSONTyped(json, false);
}

export function ListAdminRegions200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ListAdminRegions200Response {
  if (json == null) {
    return json;
  }
  return {
    data: (json['data'] as Array<any>).map(AdminRegionFromJSON),
  };
}

export function ListAdminRegions200ResponseToJSON(
  json: any,
): ListAdminRegions200Response {
  return ListAdminRegions200ResponseToJSONTyped(json, false);
}

export function ListAdminRegions200ResponseToJSONTyped(
  value?: ListAdminRegions200Response | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    data: (value['data'] as Array<any>).map(AdminRegionToJSON),
  };
}
